import {api}from './api'; // your axios instance
import { jwtDecode } from 'jwt-decode';


const apiLogin = async ({ username, password }) => {
  try {
    const correlationId = crypto.randomUUID();

    //  Get JWT Token
    const loginResponse = await api.post(
      '/Account/login',
      {
        username,
        password,
      },
      {
        headers: {
          'X-CORRELATION-ID': correlationId,
        },
      }
    );

    const { token, sessionId } = loginResponse.data;

    const decodedToken = jwtDecode(token);

   

    //  Get remaining user details
    const userResponse = await api.post(
      '/Account/UserDetails',
      {
        username,
        password,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'X-CORRELATION-ID': correlationId,
        },
      }
    );

    return {
      ...userResponse.data,

      // Values from JWT
      userRole: decodedToken.role_name,
      emailId: decodedToken.email,
      role:decodedToken.role,

      token,
      sessionId,
    };
  } catch (error) {
    if (error.response) {
      const { data } = error.response;

      if (data?.errorMessages?.length > 0) {
        const message = data.errorMessages[0].message;

        if (message === 'User is inactive') {
          throw new Error('Please reach out back to admin');
        }

        throw new Error(message);
      }
    }

    throw new Error('Invalid Email or Password');
  }
};

export default apiLogin;

